import { ButtonProps } from '@mui/material'
import { useState } from 'react'

export const useConfirmationDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const confirmationHandler: ButtonProps['onClick'] = event => {
    event.preventDefault()
    setIsDialogOpen(true)
  }

  return {
    confirmationHandler,
    isDialogOpen,
    setIsDialogOpen,
  }
}
